import React from "react";
import { RouterProvider } from "react-router-dom";

import { FirebaseProvider, AuthProvider, StoreProvider } from "@contexts";
import { router } from "@utils";

function App() {
  return (
    <FirebaseProvider>
      <AuthProvider>
        <StoreProvider>
          <RouterProvider router={router} />
        </StoreProvider>
      </AuthProvider>
    </FirebaseProvider>
  );
}

export default App;
